import { Component, Input } from '@angular/core';

// Menu "Scegli" delle righe di tabella: le voci (a.dropdown-item) arrivano via ng-content.
// Gli stili sono globali in styles.scss perché il menu può essere spostato nel container.
@Component({
  selector: 'sacbo-row-actions',
  templateUrl: './row-actions.component.html'
})
export class RowActionsComponent {
  // selettore dove agganciare il menu (es. '.content-wrapper' per le tabelle responsive)
  @Input() container: string;
  @Input() label = 'common.action_txt';
}
